<template>
  <div>
    <v-hover v-slot="{ hover }" :disabled="disabled">
      <v-card
        height="175"
        width="175"
        :class="[
          'rounded-10',
          'blue-border',
          { 'btn-primary': hover, 'disabled-button': disabled }
        ]"
        v-ripple
        @click="$emit('chooseOrder', 'DESIGN')"
      >
        <v-card-text
          class="px-1 text-center text-subtitle-1 pb-0"
          :style="{
            color: hover ? 'white' : '#147BD1'
          }"
        >
          <strong> MILLED BAR </strong>
        </v-card-text>
        <v-card-text
          class="pa-0 text-center text-caption"
          :style="{
            color: hover ? 'white' : '#147BD1'
          }"
        >
          OSTEON TOOTH DESIGN OR PROVIDED TOOTH DESIGN
        </v-card-text>
        <v-container fluid>
          <v-img
            v-if="!hover"
            contain
            :src="require('@/assets/design-only-prosthesis-with-bar.png')"
            position="center center"
          />
          <v-img
            v-if="hover"
            contain
            :src="require('@/assets/design-only-prosthesis-with-bar-white.png')"
            position="center center"
          />
        </v-container>
      </v-card>
    </v-hover>
    <v-card flat max-width="275px">
      <v-card-actions class="pb-0">
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              elevation="0"
              fab
              x-small
              @click="collapsed = !collapsed"
            >
              <v-icon>
                {{ collapsed ? "mdi-information-outline" : "mdi-chevron-up" }}
              </v-icon>
            </v-btn>
          </template>
          <span>Click for further info</span>
        </v-tooltip>
        <v-spacer />
      </v-card-actions>
      <v-card-text class="text-left pa-2 pb-0">
        <ul>
          <li class="font-weight-bold pb-1">
            Nexus milled bar and split file overlay.
          </li>
          <li class="pb-1">Upload or choose existing arch design.</li>
          <li class="pb-1">Nexus-style bar matched to design.</li>
          <li>
            Receive milled bar, screws, overlay model and finishing models.
          </li>
        </ul>
      </v-card-text>
      <v-expand-transition>
        <v-card-text class="py-2 mx-2 text-left" v-if="!collapsed">
          <v-divider class="py-1" />
          Milled Bar orders from Osteon Medical are per arch. Bars match an
          uploaded arch design, or match an existing design from Osteon. All
          bars are designed as Nexus final restorations, keeping in mind the
          Nexus Design Parameters. Includes necessary straight and ASC screws
          (if implemented).
          <br />
          <a
            href="https://nexusconnectlab.zendesk.com/hc/en-us/articles/12679846250255-Milled-Bar-Order"
            target="_blank"
            >Find out more via the Knowledge Base.</a
          >
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "BarButton",

  props: ["disabled"],

  data() {
    return {
      collapsed: true
    }
  }
}
</script>

<style scoped>
.disabled-button {
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(10%) brightness(80%);
  opacity: 0.5;
}
</style>
